import React, { useState, useEffect, useRef, memo} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getToday } from '@common/utils/date';
import Layout from '@components/common/Layout';

import {getRoleMenuList, updateSearchRoleMenuInfo, saveApplicationRoleMenu, getApplicationRolesWithNoPaging, 
        getApplicationRolesUseYn, getApplicationRoleDetail, roleMenuExcelDownload, updateRoleMenuClear, searchRoleMenuInfoClear} from '@store/actions/roleMenuAction';
import RoleMainList from '@components/role/RoleMainList';
import RoleInfoList from '@components/roleMenu/RoleInfoList';
import {showModal} from '@store/actions/commonAction';
 
const RoleMenu = () => {  
    
    const dispatch = useDispatch();
    const [roleSelCd, setRoleSelCd] = useState('');
    const [pageNum, setPageNum] = useState(0);    
    const [readYn, setReadYn] = useState(true); 
    const [initial, setInitial] = useState(false);        
    const { searchRoleMenuInfo, roleMenuList, searchRoleList, roleUseYList, roleUseYListCount } = useSelector(state => state.roleMenuReducer);
    const [roleMenuVisible, setRoleMenuVisible] = useState(true);
    const [gridClass, setGridClass] = useState('check-wrap chk-style disabled');
    const [selectRow, setSelectRow] = useState({
        rowIndex : '' 
    });

    useEffect(() => {

        //검색조건 초기화
        dispatch(searchRoleMenuInfoClear());
        
        //권한목록 조회
        dispatch(
            getApplicationRolesUseYn({
                aplctnTpCd:searchRoleMenuInfo.aplctnTpCd,
                aplctnDvcTyCd:searchRoleMenuInfo.aplctnDvcTyCd,
                useYn:'Y'
            })
        );  

        //검색용 권한별 메뉴 조회
        dispatch(
            getApplicationRolesWithNoPaging({
                useYn:'Y'
            })
        );

        dispatch(updateRoleMenuClear());
        
    }, []); 

    const rowSelect = (row) => {

        setSelectRow({
            rowIndex : row.rowIndex
        })

        const data = Object.values(roleUseYList).filter(f => f.roleId === row.roleId);       

        dispatch(
            getRoleMenuList({
                aplctnTpCd: '01',
                aplctnDvcTyCd: searchRoleMenuInfo.aplctnDvcTyCd, 
                roleId: data[0].roleId
            })
        );

        dispatch(
            updateSearchRoleMenuInfo({
                roleId:data[0].roleId
            })
        );
        
    }

    const handleChangeSelect = (e) => {
        setRoleSelCd({
            roleId:e.target.value
        })

        dispatch(
            updateSearchRoleMenuInfo({
                ...searchRoleMenuInfo,
                roleId:e.target.value
            })
        );
    }

    const roleSearch = () => {        
        
        if(roleSelCd.roleId === '' || roleSelCd.roleId === undefined) {

             //권한목록 조회
            dispatch(
                getApplicationRolesUseYn({
                    aplctnTpCd:searchRoleMenuInfo.aplctnTpCd,
                    aplctnDvcTyCd:searchRoleMenuInfo.aplctnDvcTyCd,
                    useYn:'Y',
                    targetRow:1,
                    callback:callBckFun
                })
            );

        }else{

             //권한목록 조회
             dispatch(
                getApplicationRoleDetail({                
                    aplctnTpCd:searchRoleMenuInfo.aplctnTpCd,
                    roleId:roleSelCd.roleId,
                    targetRow:1
                })
            );
            
            //권한별 메뉴 조회
            dispatch(
                getRoleMenuList({
                    aplctnTpCd:searchRoleMenuInfo.aplctnTpCd,
                    aplctnDvcTyCd:'01', 
                    roleId:roleSelCd.roleId
                })            
            );

        }

        setSelectRow({
            rowIndex : 0
        });

        setInitial(true);
    }

    const callBckFun = () => {        
         
        setSelectRow({
            rowIndex : ''
        });
        setPageNum('0');
        dispatch(updateRoleMenuClear());
    }

    const edit = () => {

        if(searchRoleMenuInfo.roleId === '') {
            dispatch(
                showModal({
                    visible: true,
                    type: 'info',
                    msg: '수정할 권한을 선택해주세요.',
                })
            );
        }else{
            setGridClass('check-wrap chk-style');
            setRoleMenuVisible(false);
            setReadYn(false);
        }

    }

    const cancel = () => {
        
        dispatch(
            updateSearchRoleMenuInfo({
                ...searchRoleMenuInfo,
                roleId:''
            })
        );
    
        //권한목록 조회
        dispatch(
            getApplicationRolesUseYn({
                aplctnTpCd:searchRoleMenuInfo.aplctnTpCd,
                aplctnDvcTyCd:searchRoleMenuInfo.aplctnDvcTyCd,
                useYn:'Y',
                targetRow:1,
                callback:callBckFun
            })
        );

        setGridClass('check-wrap chk-style disabled');
        setRoleMenuVisible(true);
        setReadYn(true);
        setInitial(true);

        dispatch(updateRoleMenuClear());
        
    }

    const save = () => {
        
        const selectMenuList = roleMenuList.filter(item => item.isChecked === true);               

        if(selectMenuList.length === 0) {
            dispatch(
                showModal({
                    visible: true,
                    type: 'info',
                    msg: '1개이상의 메뉴를 선택해주세요.'
                })
            );
        }else{
            const List = Object.values(roleMenuList).map(f => f.isChecked === true ? 
                    {...f, useYn:'Y', roleId:searchRoleMenuInfo.roleId, aplctnTpCd:searchRoleMenuInfo.aplctnTpCd, aplctnDvcTyCd:searchRoleMenuInfo.aplctnDvcTyCd} : {...f, useYn:'N', roleId:searchRoleMenuInfo.roleId, aplctnTpCd:searchRoleMenuInfo.aplctnTpCd, aplctnDvcTyCd:searchRoleMenuInfo.aplctnDvcTyCd});
    
            dispatch(
               saveApplicationRoleMenu({
                   List,
                   callback: handleVerifyCallcakfunc,
                })
            );
        }

    }

    const handleVerifyCallcakfunc = (status, type) => {

        dispatch(
            getRoleMenuList({
                aplctnTpCd:searchRoleMenuInfo.aplctnTpCd,
                aplctnDvcTyCd:searchRoleMenuInfo.aplctnDvcTyCd, 
                roleId:searchRoleMenuInfo.roleId
            })            
        );
        
        setGridClass('check-wrap chk-style disabled');
        setRoleMenuVisible(true);
        setReadYn(true);

    };

    const pageChange = (value) => {

        //권한목록 조회
        dispatch(
            getApplicationRolesUseYn({
                aplctnTpCd:searchRoleMenuInfo.aplctnTpCd,
                aplctnDvcTyCd:searchRoleMenuInfo.aplctnDvcTyCd,
                useYn:'Y',
                targetRow:value*10+1
            })
        );

        setSelectRow({
            rowIndex : ''
        });

        setInitial(false);

        dispatch(updateRoleMenuClear());
        
    }

    const excelDown = () => {        
        const today = getToday('yyyyMMddHHmm');

        if(searchRoleMenuInfo.roleId === '') {
            dispatch(
                showModal({
                    visible: true,
                    type: 'info',
                    msg: '다운로드할 데이터가 없습니다.',
                })
            );
        }else{
            dispatch(
                roleMenuExcelDownload(
                    {
                        aplctnTpCd : searchRoleMenuInfo.aplctnTpCd,
                        aplctnDvcTyCd : searchRoleMenuInfo.aplctnDvcTyCd,
                        roleId : searchRoleMenuInfo.roleId,
                        excelFileName : '권한별메뉴관리_'+today+'.xlsx'
                    }
                )
            )
        }
    }

    return (
        <React.Fragment>
            <Layout>            
                <div className="content manage-content">
                    <div className="con-wrap">
                        <div className="app-wrap">
                            <div className="app-box">
                                <div className="con-bottom">
                                        <div className="tit-area">
                                            <h2 className="tit-con">권한별 메뉴 관리</h2>
                                        </div>                                    
                                            <div className="search-box">
                                                <div className="data-group-left">
                                                    <div className="data-area">
                                                        <span className="data-tit">권한</span>
                                                        <div className="sel-group" style={{width:'100%'}}>                                                    
                                                            <select  onChange={handleChangeSelect}>
                                                                <option value="">전체</option>
                                                                {searchRoleList.map(option => (
                                                                    <option value={option.roleId} key={option.roleId}>{option.roleNm}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button className="btn-search" onClick={() => roleSearch()}>검색</button>
                                            </div>                                            
                                            <div className="col-tbl-wrap mgt-0">
                                                <RoleMainList
                                                    list={roleUseYList} 
                                                    totalCount={roleUseYListCount} 
                                                    pageNum={pageNum}
                                                    rowSelect={rowSelect}
                                                    selectRow={selectRow}
                                                    pageChange={pageChange}
                                                    initial={initial}
                                                />
                                                <RoleInfoList
                                                    list={roleMenuList}
                                                    readYn={readYn}
                                                    gridClass={gridClass}
                                                />
                                            </div>
                                        </div>
                                        {roleMenuVisible ? (<div className="btn-area-jb">
                                            <div className="btn-area-l">
                                                <button className="memo-reg" onClick={() => excelDown()}>
                                                    <span className="ico ico-exl-down"></span>
                                                    엑셀 다운로드
                                                </button>
                                            </div>
                                            <ul className="file-list">
                                                <li>
                                                    <button className="btn-m modify" onClick={() => edit()}>수정</button>
                                                </li>
                                            </ul>
                                        </div>):(<div className="btn-area-jb">
                                        <ul className="file-list">
                                            <li>
                                                <button className="btn-m cancel" onClick={() => cancel()}>취소</button>
                                            </li>
                                            <li>
                                                <button className="btn-m save" onClick={() => save()}>저장</button>
                                            </li>
                                        </ul>
                                </div>)}
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </React.Fragment>
    )

};

export default memo(RoleMenu); 